<template>
<div>
    <div class="box-header">
      <h3 class="box-title title">Citas de Recepción</h3>
    </div>
  <div class="box box-success">
       <div class="box-header title-boreder">
      <h3 class="box-title box-title-sub">
        <img class="icon-space" src='/static/img/icons/search.png' style="padding-bottom:7px"> Buscar Cita</h3>
    </div>
    <div class="box-body">
      <div class="filterContainer">
        <div class="row">
          <div class="col-md-4">
            <div id="divAccountSelect" class="form-group">
              <label>Cuenta</label>  
              <multiselect
                :value="this.selectedAccount"
                selectLabel=""
                selectedLabel=""
                deselectLabel=""
                track-by="name"
                :placeholder="this.selectedAccount.name"
                :allow-empty="false"
                label="name"
                :options="this.optionsAccount"
                @input="onAccountSelect">
                <span slot="noResult">
                  No se encontraron resultados
                </span>
              </multiselect>
            </div>
          </div>
          <div class="col-md-8 form-interspace">
            <div class="form-group pull-left" style="padding-top:25px;">
              <router-link :to="{name: 'ReceptionAppointmentsUpload', params: {accountCode: this.selectedAccount.code} }" tag="button" class="btn btn-success">Nuevo Documento</router-link>
            </div>
          </div>
        </div>
      </div>
      
      <div class="row">
        <div class="col-md-12">
          <br/>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12"  id="receptionTable">
          <vuetable 
            id="receptionTable"
            ref="vuetable"
            :api-mode="false"
            :fields="tableFields"
            :data="tableData"
            :css="tableCSS.table"
            @vuetable:loading="onLoading"        
            @vuetable:loaded="onLoaded"
            noDataTemplate="No se encontraron resultados"
          >
          </vuetable>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import Vuetable from 'vuetable-2'
import moment from 'moment/moment.js'

export default {
  name: 'ReceptionAppointments',
  data () {
    return {
      loader: null,
      optionsAccount: null,
      selectedAccount: null,
      tableData: null,
      tableFields: [
        {
          name: 'accountCode',
          title: 'Cliente',
          callback: 'formatClient'
        },
        {
          name: 'filename',
          title: 'Documento'
        },
        {
          name: 'uploaded',
          title: 'Fecha de Carga',
          callback: 'formatDate'
        },
        {
          name: 'uploadedBy',
          title: 'Cargado Por'
        }
      ],
      tableCSS: {
        table: {
          tableClass: 'table table-striped table-bordered table-hovered'
        }
      },
      tableOptions: {
        headings: {
          accountCode: 'Cliente',
          fileName: 'Documento',
          uploaded: 'Fecha de Carga',
          uploadedBy: 'Cargado Por'
        },
        filterable: false,
        texts: {
          count: ''
        }
      }
    }
  },
  components: {
    Multiselect,
    Vuetable
  },
  computed: {
    ...mapGetters([
      'userClients'
    ])
  },
  created () {
    this.optionsAccount = Array.from(this.userClients)
    this.selectedAccount = this.optionsAccount[0]
    this.loadTableData()
  },
  methods: {
    ...mapActions([
      'fetchReceptionAppointmentDocumentList'
    ]),
    loadTableData () {
      this.loader = this.$loading.show({
        loader: 'dots'
      })

      this.fetchReceptionAppointmentDocumentList(this.selectedAccount.code).then((data) => {
        if (data != null) {
          this.tableData = data
          this.loader.hide()
        }
      })
    },
    /* DropDownList Events */
    onAccountSelect (account) {
      this.selectedAccount = account
      this.loadTableData()
    },
    /* Table Events */
    onLoading () {
      this.loader = this.$loading.show({
        loader: 'dots'
      })
    },
    onLoaded () {
      this.loader.hide()
    },
    formatClient (value) {
      return this.optionsAccount.filter(item => item.code === value)[0].name
    },
    formatDate (value) {
      return moment(value).format('DD/MM/YYYY')
    }
  },
  destroyed () {
    if (this.loader !== null) {
      this.loader.hide()
    }
  }
}
</script>

<style>


#divAccountSelect, #divSearchSelect{ 
  height: 34px;
}

#divAccountSelect.multiselect__tags, #divSearchSelect .multiselect__tags{ 
  border-radius: 0px !important;
  min-height: 34px;
  height: 34px;
}

#divAccountSelect .multiselect__select{ 
  border-radius: 0px !important;
  height: 34px;
}

@media screen and (max-width: 600px) {

   #receptionTable table {
      border: 0;
    }

   #receptionTable thead {
      display: none;
    }

   #receptionTable table tr {
      margin-top: 10px;
      margin-bottom: 20px;
      display: block;
	    border:  3px solid;
      border-color:#F2F4F6;
      background-color: white !important;
    }

   #receptionTable table td {
      display: block;
      border: none !important;
      font-size: 13px;
      text-align: right;
      
    }

   #receptionTable table td:last-child {
      border-bottom: 0;
    }

    #receptionTable table td div::before{
      content: attr(id);
      float: left;
      text-transform: uppercase;
      font-weight: bold;
    }
    	#receptionTable	tbody{
			line-height:0!important;
		}

    .table-btn {
    float: none !important;
    background: none !important;
}

  }

</style>



// WEBPACK FOOTER //
// ReceptionAppointments.vue?ba891454